export const CMS_ITEMS = {
	AIRLINE: "airlines",
};

export const CMS_PARAMS = {
	airline: {
		fields: "name, icon, small_icon, display_name, short_code",
	},
};
